// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BtnDisabledController from "./btn_disabled_controller"
application.register("btn-disabled", BtnDisabledController)

import CountrySelectController from "./country_select_controller"
application.register("country-select", CountrySelectController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import CurrentLinkController from "./current_link_controller"
application.register("current-link", CurrentLinkController)

import DentalServiceFormController from "./dental_service_form_controller"
application.register("dental-service-form", DentalServiceFormController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import CreditNoteFormController from "./credit_note_form_controller"
application.register("credit-note-form", CreditNoteFormController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FlowbiteTabsController from "./flowbite_tabs_controller"
application.register("flowbite-tabs", FlowbiteTabsController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import OdontogramController from "./odontogram_controller"
application.register("odontogram", OdontogramController)

import PreInvoiceController from "./pre_invoice_controller"
application.register("pre-invoice", PreInvoiceController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import QuickTreatmentPickerController from "./quick_treatment_picker_controller"
application.register("quick-treatment-picker", QuickTreatmentPickerController)

import RansackController from "./ransack_controller"
application.register("ransack", RansackController)

import RemoteTomSelectController from "./remote_tom_select_controller"
application.register("remote-tom-select", RemoteTomSelectController)

import ScrollToErrorsController from "./scroll_to_errors_controller"
application.register("scroll-to-errors", ScrollToErrorsController)

import SessionTimeoutHandlerController from "./session_timeout_handler_controller"
application.register("session-timeout-handler", SessionTimeoutHandlerController)

import ShortcutMultipleSelectController from "./shortcut_multiple_select_controller"
application.register("shortcut-multiple-select", ShortcutMultipleSelectController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SimpleDropzoneController from "./simple_dropzone_controller"
application.register("simple-dropzone", SimpleDropzoneController)

import SoftTissueDiagramController from "./soft_tissue_diagram_controller"
application.register("soft-tissue-diagram", SoftTissueDiagramController)

import SoftTissueViewController from "./soft_tissue_view_controller"
application.register("soft-tissue-view", SoftTissueViewController)

import SymbolSelectController from "./symbol_select_controller"
application.register("symbol-select", SymbolSelectController)

import TabRoleSelectedController from "./tab_role_selected_controller"
application.register("tab-role-selected", TabRoleSelectedController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TemplateTreatmentPlanController from "./template_treatment_plan_controller"
application.register("template-treatment-plan", TemplateTreatmentPlanController)

import TreatmentSelectorController from "./treatment_selector_controller"
application.register("treatment-selector", TreatmentSelectorController)

import TreatmentTypeSelectorController from "./treatment_type_selector_controller"
application.register("treatment-type-selector", TreatmentTypeSelectorController)

import PaymentCalculatorController from "./payment_calculator_controller"
application.register("payment-calculator", PaymentCalculatorController)

import InvoicePreviewController from "./invoice_preview_controller"
application.register("invoice-preview", InvoicePreviewController)
